import React from 'react';

import { Field } from '../../../../../../shared/components/Form';
import { t } from '../../../../../../shared/components/l10n/l10n';
import { SendAsEmail } from '../../../shared/components/SendBy';

export default function MoneyflowEInvoiceDrawer({ emails }: { emails: string[] }) {
    return (
        <div style={{ marginTop: '3rem' }}>
            <SendAsEmail
                title={t`FORM_BOOKANDSEND_MONEYFLOW_SELECTEMAIL_TITLE`}
                text={t`FORM_BOOKANDSEND_MONEYFLOW_SELECTEMAIL_TEXT`}
            />

            <Field.Dropdown
                label={t`FORM_BOOKANDSEND_MONEYFLOW_SELECTEMAIL`}
                name="moneyflowEinvoiceEmail"
                options={[
                    ...emails.map((email, index) => ({
                        text: email,
                        value: index,
                    })),
                ]}
            />
        </div>
    );
}
